<template>
<div class="wrapper">
  <div v-if="!loading">
      <div>
        <CButton class="col-1 mt-3 " variant="outline" color="info" @click="print()">Print</CButton>
        <CButton class="col-3 mt-3 " variant="outline" color="info">
          <download-excel
            :data="json_data"
            :fields="json_fields"
            :name= "filename"
          >
            Download Excel
          </download-excel>
        </CButton>
      </div>
      <br>
      <div class="panel-body" id="print">
        <h3>Icare {{icarename }} Report Attendance</h3>
        <h6>Period: {{ period }}</h6>
        <br>
        <table class="table" style="width:1000px">
          <thead>
            <tr>
              <th style="width: 10px;">#</th>
              <th style="width: 200px;">Fullname</th>
              <th v-for="(dt_header, index) in header" :key="index" style="width: 200px;">{{ dt_header.icaredate }}</th>
              <!-- <th style="width: 200px;">Visitor Attendance</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dt, index) in rpt" :key="index">
              <td>{{ index+1 }}</td>
              <td>{{ dt['fullname'] }}</td>
              <td v-for="(dt_header, index) in header" :key="index" style="width: 200px;">{{ dt[dt_header.icaredate] }}</td>
              <!-- <td>{{ dt.count_visitor }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>    
  </div>
  <div v-else class="d-flex content-center min-vh-100">
      <b-spinner variant="primary" label="Spinning"><br></b-spinner>
  </div>


</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import report from '@/services/report';

import Vue from "vue";
import JsonExcel from "vue-json-excel";

import moment from 'moment';
 
Vue.component("downloadExcel", JsonExcel);

export default {
  
    data(){
        return{
          rpt:'',
          header:'',
          period:'',
          icarename:'',
          loading: false,
          filename: "a.xls",
          json_fields: {
              "Fullname": "fullname",
          },
          json_data: [],
          json_meta: [
            [
              {
                key: "charset",
                value: "utf-8",
              },
            ],
          ],
        }
    },
    created(){
      this.loadData()
    },
    mounted() {
      
    },
   
    methods: {
      loadData(){
        var params = {
          icare: this.$route.query.icare,
          // month: this.$route.query.month,
          // year: this.$route.query.year
          from: this.$route.query.from,
          to: this.$route.query.to,
        }
        this.loading = true
        report.getIcareReportMonthAttendance(params)
        .then(res => {
            let getData = res.datatable
            this.header = res.header_date
            //this.period = res.periodMonth + ' ' + res.periodYear
            this.period = moment(res.from).format('DD/MM/YYYY') + ' to ' + moment(res.to).format('DD/MM/YYYY')
            this.icarename = res.icare.name
            this.filename = "Icare " + res.icare.name + " Report Attendance " + this.period

        for(let i = 0; i <= res.header_date.length-1; i++){
          this.json_fields[res.header_date[i].icaredate] = res.header_date[i].icaredate
        }

        // this.json_fields["y"] = "yy"
        // this.json_fields["z"] = "zz"
        //this.json_fields = JSON.parse(this.json_fields)

            this.rpt = getData
            this.json_data = getData
            this.loading = false
        }).catch ((err) => { 
          alert(err.response.data.message)
        })

        // var obj = JSON.parse(this.json_fields);
        // obj.push({"y":"y"})
        // this.json_fields = JSON.stringify(obj);



        // var myJsonObject = JSON.parse(this.json_fields)
        // myJsonObject['y'] = "yy";
        // this.json_fields = myJsonObject




      },
      print () {
        // Pass the element id here
        this.$htmlToPaper('print', null, () => {
          console.log('Printing completed or was cancelled!');
        });
      },
    }
}
</script>
